import {
  type RepoPullRequest,
  RepoPullRequestDisplayState,
} from '@github-ui/dotcom-schema/types/pull_requests/v1/repo_pulls_dashboard'

export type StackSegmentState = 'merged' | 'queued' | 'open' | 'draft' | 'closed' | 'unmerged'

export const MAX_STACK_SEGMENTS = 10

export function mergedSegments(
  mergedCount: number,
  size: number,
  unmergedState: 'unmerged' | 'closed' = 'unmerged',
): StackSegmentState[] {
  const merged = Math.min(mergedCount, size)
  return Array.from({length: size}, (_, index) => (index < merged ? 'merged' : unmergedState))
}

export function meterParts(segments: readonly StackSegmentState[]) {
  const continuous = segments.length > MAX_STACK_SEGMENTS
  const parts: Array<{state: StackSegmentState; length: number}> = []

  for (const state of segments) {
    const previous = parts.at(-1)
    if (continuous && previous?.state === state) {
      previous.length += 1
    } else {
      parts.push({state, length: 1})
    }
  }

  return {continuous, parts}
}

export function stateSegments(pullRequests: ReadonlyArray<Pick<RepoPullRequest, 'displayState'>>): StackSegmentState[] {
  return pullRequests.toReversed().map(pull => {
    switch (pull.displayState) {
      case RepoPullRequestDisplayState.MERGED:
        return 'merged'
      case RepoPullRequestDisplayState.QUEUED:
        return 'queued'
      case RepoPullRequestDisplayState.DRAFT:
        return 'draft'
      case RepoPullRequestDisplayState.CLOSED:
        return 'closed'
      default:
        return 'open'
    }
  })
}
